import Box from "@mui/material/Box";
import { useSelector } from "react-redux";

export const SCALE_ZOOM_THRESHOLD = 20;

const gridmodeContainer_ = (theme) => ({
  top: "0px !important",
  left: "0px !important",
  width: "100% !important",
  height: "100% !important",
  // direction: "ltr !important",
  position: "fixed !important",
  pointerEvents: "none !important",
  zIndex: 0,

  // Our theme hides mui components when printing.
  // However, we want THIS to show.
  "@media print": {
    visibility: "visible !important",
  },
});

export default function Scale() {
  const { pxPerFt, gridVisible } = useSelector((state) => state.scaleReducer);
  const { zoom } = useSelector((state) => state.mapReducer);

  if (zoom < SCALE_ZOOM_THRESHOLD || !gridVisible || !pxPerFt) {
    return null;
  }

  return (
    <Box id="scale-grid-container" sx={gridmodeContainer_}>
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        <defs>
          <pattern
            id="grid-pattern"
            width={pxPerFt}
            height={pxPerFt}
            patternUnits="userSpaceOnUse"
          >
            <path
              d={`M ${pxPerFt} 0 L 0 0 0 ${pxPerFt}`}
              fill="none"
              stroke="#909090"
              strokeWidth="1.0"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid-pattern)" />
      </svg>
    </Box>
  );
}
